// For Loading
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
// For Unauthorization 
export const UNAUTHORIZED_DASHBOARD = "UNAUTHORIZED_DASHBOARD"
// Fetch Dashboard Data
export const FETCH_DASHBOARD_DATA = "FETCH_DASHBOARD_DATA"

export const ACCOUNT_DASH = "ACCOUNT_DASH"

